import { render, staticRenderFns } from "./CreateSettings.vue?vue&type=template&id=768dc780&"
import script from "./CreateSettings.vue?vue&type=script&lang=ts&"
export * from "./CreateSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports